<script setup lang="ts">
import Logo from '@kidzonet/logo'

interface LogoProps {
    fill: string
}

defineProps<LogoProps>()
</script>

<template>
    <router-link
        :to="{ name: 'home' }"
        aria-label="Return to main page"
    >
        <Logo
            class="main-menu-logo"
            :fill="fill"
        />
    </router-link>
</template>

<style>
    .main-menu-logo {
        margin: 3.5em 2.5em 2em;
    }
</style>
